var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSourceRenewable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#00F77B",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12 3 8.889 6 12 9V6.75c3.001 0 5.444 2.355 5.444 5.25 0 .66-.132 1.29-.364 1.872l1.179 1.135c.47-.906.741-1.925.741-3.007 0-3.721-3.14-6.75-7-6.75V3zM5.741 8.993A6.505 6.505 0 0 0 5 12c0 3.722 3.14 6.75 7 6.75V21l3.111-3L12 15v2.25c-3.001 0-5.444-2.355-5.444-5.25 0-.66.132-1.29.364-1.872L5.741 8.993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSourceRenewable);
export default __webpack_public_path__ + "static/media/icon-source-renewable.41798540c509feec240757d7a8405154.svg";
export { ForwardRef as ReactComponent };